import { render, staticRenderFns } from "./SocketError.vue?vue&type=template&id=11fc2df2&scoped=true&"
import script from "./SocketError.vue?vue&type=script&lang=js&"
export * from "./SocketError.vue?vue&type=script&lang=js&"
import style0 from "./SocketError.vue?vue&type=style&index=0&id=11fc2df2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11fc2df2",
  null
  
)

export default component.exports